import * as srExtension from 'sr-scratch-extension/dist/index'
const { translationGUI } = srExtension.default;

const en = require('./en.json');
const ja = require('./ja.json');
const jaHira = require('./ja-Hira.json');

const enBlock = translationGUI.en;
const jaBlock = translationGUI.ja;
const jaHiraBlock = translationGUI['ja-Hira'];

var translations = {
  en: { ...en, ...enBlock },
  ja: { ...ja, ...jaBlock },
  'ja-Hira': { ...jaHira, ...jaHiraBlock },
};
export {
  translations as default,
};